import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found.component';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent) },
  { path: '**', component: NotFoundComponent }
];
